module.exports = __webpack_public_path__ + "img/2934.dd6bce79.svg";